import * as React from 'react';
import { Input } from '@ixicare/ui';
import { Field, FieldValue } from '../schema';
import styles from '../styles.module.css';

interface Props {
  field: Field;
  value: FieldValue;
  label: React.ReactNode;
  error?: string;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

const NumberFieldControl: React.FC<Props> = ({ field, value, label, error, onChange, disabled }) => {
  const handle = (raw: string) => {
    if (raw === '') {
      onChange(null);
      return;
    }
    const n = Number(raw);
    onChange(Number.isNaN(n) ? null : n);
  };

  return (
    <div className={styles.numberField}>
      <Input
        label={label}
        type="number"
        value={value == null ? '' : String(value)}
        onValueChange={handle}
        disabled={disabled}
        error={error}
      />
      {field.deprecated_since && (
        <span className={styles.deprecatedPill}>Deprecated &gt; {field.deprecated_since}</span>
      )}
    </div>
  );
};

export default NumberFieldControl;
